<template>
  <div>
    <h1>Card issuers</h1>
    <v-btn @click="showIssuer">
      <v-icon>add</v-icon>Card issuer
    </v-btn>
    <v-btn @click="showIssuerlength">
      <v-icon>add</v-icon>Issuer length
    </v-btn>
    <v-btn @click="showIssueriin">
      <v-icon>add</v-icon>Issuer iin
    </v-btn>
    <table border="1">
      <tr>
        <th>Name</th>
        <th>Image</th>
        <th>Lengths</th>
        <th>IINs</th>
        <th />
      </tr>
      <tr v-for="issuer in computedIssuers" :key="issuer.id">
        <td>{{issuer.name}}</td>
        <td>{{issuer.image}}</td>
        <td>
          <div v-for="issuerlength in issuer.issuerlengths" :key="issuerlength.id">
            <span>{{`${issuerlength.start}:${issuerlength.end}`}}</span>
            <a @click="removeIssuerLength(issuerlength)">x</a>
          </div>
        </td>
        <td>
          <div v-for="issueriin in issuer.issueriins" :key="issueriin.id">
            <span>{{`${issueriin.start}:${issueriin.end}`}}</span>
            <a @click="removeIssuerIin(issueriin)">x</a>
          </div>
        </td>
        <td>
          <v-btn @click="removeIssuer(issuer)" color="error" small>
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </tr>
    </table>
    <v-dialog v-model="dialogIssuer" width="300">
      <v-card>
        <v-card-text>
          <h3>Card issuer</h3>
          <p>Please enter details for this debit or credit card issuer</p>
          <v-text-field label="Name" v-model="issuer.name" outline />
          <v-text-field label="Image" v-model="issuer.image" outline />
          <v-btn @click="addIssuer">
            <v-icon>save</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogIssuerlength" width="300">
      <v-card>
        <v-card-text>
          <h3>Card number length</h3>
          <p>Please enter card number length for this issuer</p>
          <v-select
            label="Issuer"
            v-model="issuerlength.issuerid"
            :items="issuers"
            item-value="id"
            item-text="name"
            outline
          />
          <v-text-field type="number" label="Start" v-model.number="issuerlength.start" outline />
          <v-text-field type="number" label="End" v-model.number="issuerlength.end" outline />
          <v-btn @click="addIssuerlength">
            <v-icon>save</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogIssueriin" width="300">
      <v-card>
        <v-card-text>
          <h3>Issuer IIN</h3>
          <p>Please enter start and end of IIN numbers</p>
          <v-select
            label="Issuer"
            v-model="issueriin.issuerid"
            :items="issuers"
            item-value="id"
            item-text="name"
            outline
          />
          <v-text-field type="number" label="Start" v-model.number="issueriin.start" outline />
          <v-text-field type="number" label="End" v-model.number="issueriin.end" outline />
          <v-btn @click="addIssueriin">
            <v-icon>save</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Issuers",
  metaInfo() {
    return {
      title: "Issuers",
      titleTemplate: "%s - Payments - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedIssuers() {
      if (!this.issuers) {
        return undefined;
      }
      return this.issuers.map(i => {
        const issuerlengths = this.issuerlengths
          ? this.issuerlengths[i.id]
          : undefined;
        const issueriins = this.issueriins ? this.issueriins[i.id] : undefined;
        return { ...i, issuerlengths, issueriins };
      });
    }
  },
  data() {
    return {
      issuers: null,
      issuerlengths: null,
      issueriins: null,
      dialogIssuer: false,
      dialogIssuerlength: false,
      dialogIssueriin: false,
      issuer: {},
      issuerlength: {},
      issueriin: {}
    };
  },
  methods: {
    fetchIssuers() {
      nbmlaw.get(`/cors/admin/payment/issuers`).then(response => {
        // console.log(response.data);
        this.issuers = response.data;
      });
    },
    fetchIssuerlengths() {
      nbmlaw.get(`/cors/admin/payment/issuers/issuerlengths`).then(response => {
        // console.log(response.data);
        this.issuerlengths = response.data;
      });
    },
    fetchIssueriins() {
      nbmlaw.get(`/cors/admin/payment/issuers/issueriins`).then(response => {
        // console.log(response.data);
        this.issueriins = response.data;
      });
    },
    showIssuer() {
      this.issuer = {};
      this.dialogIssuer = true;
    },
    showIssuerlength() {
      this.issuerlength = {};
      this.dialogIssuerlength = true;
    },
    showIssueriin() {
      this.issueriin = {};
      this.dialogIssueriin = true;
    },
    addIssuer() {
      nbmlaw.post(`/cors/admin/payment/issuers`, this.issuer).then(() => {
        // console.log(response.data);
        this.update();
        this.dialogIssuer = false;
      });
    },
    addIssuerlength() {
      nbmlaw
        .post(`/cors/admin/payment/issuers/issuerlengths`, this.issuerlength)
        .then(() => {
          // console.log(response.data);
          this.update();
          this.dialogIssuerlength = false;
        });
    },
    addIssueriin() {
      nbmlaw
        .post(`/cors/admin/payment/issuers/issueriins`, this.issueriin)
        .then(() => {
          // console.log(response.data);
          this.update();
          this.dialogIssueriin = false;
        });
    },
    removeIssuer(issuer) {
      if (confirm("Are you sure?")) {
        nbmlaw.delete(`/cors/admin/payment/issuers/${issuer.id}`).then(() => {
          // console.log(response.data);
          this.update();
        });
      }
    },
    removeIssuerLength(issuerlength) {
      if (confirm("Are you sure?")) {
        nbmlaw
          .delete(`/cors/admin/payment/issuerlengths/${issuerlength.id}`)
          .then(() => {
            // console.log(response.data);
            this.update();
          });
      }
    },
    removeIssuerIin(issueriin) {
      if (confirm("Are you sure?")) {
        nbmlaw
          .delete(`/cors/admin/payment/issueriins/${issueriin.id}`)
          .then(() => {
            // console.log(response.data);
            this.update();
          });
      }
    },
    update() {
      this.fetchIssuers();
      this.fetchIssuerlengths();
      this.fetchIssueriins();
    }
  },
  created() {
    this.update();
  }
};
</script>